import styled from "styled-components";

export const MembershipWrapper = styled.div`
  width: 100%;
  margin-top: 14px;
`;

export const MembershipContainer = styled.div`
  width: 100%;
  background: #ffffff;
  border: 1px solid #d8e0f0;
  border-radius: 8px;
  padding: 16px;
  box-sizing: border-box;
`;

export const MembershipHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
`;

export const MembershipTitle = styled.h3`
  margin: 0;
  color: #2e2c34;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
`;

export const ViewAllText = styled.button`
  margin-left: auto;
  background: none;
  border: none;
  outline: none;
  padding: 0;
  color: #407bff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
`;

export const MembershipTable = styled.div`
  width: 100%;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 2fr 1fr 1fr 0.8fr;
  background: #f3f7fd;
  border-radius: 4px;
  padding: 10px 12px;
  column-gap: 12px;

  @media only screen and (max-width: 1024px) {
    display: none;
  }
`;

export const HeaderText = styled.div`
  color: #407bff;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 2fr 1fr 1fr 0.8fr;
  padding: 14px 12px;
  column-gap: 12px;
  align-items: start;

  @media only screen and (max-width: 1024px) {
    grid-template-columns: 1fr;
    row-gap: 10px;
    padding: 14px 0;
  }
`;

export const PlanNameText = styled.div`
  color: #5c667a;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  word-break: break-word;
`;

export const CellText = styled.div`
  color: #5c667a;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.5;
  word-break: break-word;
`;

export const StatusBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 74px;
  width: fit-content;
  padding: 4px 12px 4px 22px;
  border-radius: 999px;
  background: #edf9ee;
  color: #34a853;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  position: relative;
  background: ${(p) => (p.variant === "active" ? "#dff0dd" : "#fde8e3")};
  color: ${(p) => (p.variant === "active" ? "#2f9e44" : "#ff7f66")};
  &::before {
    content: "";
    position: absolute;
    left: 10px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: ${(p) => (p.variant === "active" ? "#34a853" : "#ff7f66")};
  }
`;

export const MobileLabel = styled.div`
  display: none;

  @media only screen and (max-width: 1024px) {
    display: block;
    color: #407bff;
    font-size: 11px;
    font-weight: 600;
    margin-bottom: 3px;
  }
`;

export const MobileCell = styled.div`
  display: none;

  @media only screen and (max-width: 1024px) {
    display: block;
  }
`;
